import injectReducer from 'store/injectReducer';
import {
	failureActionHandler,
	requestActionHandler,
	successActionHandler,
} from 'store';
import { ICategory, ISurveyService } from 'models';
import * as types from '../ActionTypes';
import { IServicesReducer } from '../models';

export const InitialServicesReducer: IServicesReducer = {
	isLoading: false,
	isServiceCreated: false,
	isCategoryCreated: false,
};

export default injectReducer(InitialServicesReducer, {
	[types.GET_PARTNER_CATEGORY_LIST.REQUEST]: requestActionHandler,
	[types.POST_CATEGORY.REQUEST]: requestActionHandler,

	[types.POST_SERVICE.REQUEST]: requestActionHandler,

	[types.GET_PARTNER_CATEGORY_LIST.FAILURE]: failureActionHandler,
	[types.POST_CATEGORY.FAILURE]: failureActionHandler,

	[types.POST_SERVICE.FAILURE]: failureActionHandler,
	[types.PATCH_SERVICE.FAILURE]: failureActionHandler,

	[types.RESET_IS_SERVICE_CREATED]: (state: IServicesReducer) => ({
		...state,
		isServiceCreated: false,
	}),

	[types.RESET_IS_CATEGORY_CREATED]: (state: IServicesReducer) => ({
		...state,
		isCategoryCreated: false,
	}),

	[types.GET_CATEGORY_LIST.SUCCESS]: (
		state: IServicesReducer,
		{ payload }: { payload: ICategory[] },
	) => ({
		...successActionHandler(state),
		categoryList: payload,
	}),

	[types.GET_PARTNER_CATEGORY_LIST.SUCCESS]: (
		state: IServicesReducer,
		{ payload }: { payload: ICategory[] },
	) => ({
		...successActionHandler(state),
		partnerCategoryList: payload,
	}),

	[types.GET_SA_TEMPLATE_PARTNER_CATEGORY_LIST.SUCCESS]: (
		state: IServicesReducer,
		{ payload }: { payload: ICategory[] },
	) => ({
		...successActionHandler(state),
		initialSACategoryList: payload,
	}),

	[types.GET_CATEGORY_SHORT_LIST.SUCCESS]: (
		state: IServicesReducer,
		{ payload }: { payload: ICategory[] },
	) => ({
		...successActionHandler(state),
		categoryListShort: payload,
	}),

	[types.POST_CATEGORY.SUCCESS]: (
		state: IServicesReducer,
		{ payload }: { payload: ICategory },
	) => ({
		...successActionHandler(state),
		isCategoryCreated: true,
		categoryList: [...(state.categoryList || []), payload],
	}),

	[types.POST_SERVICE.SUCCESS]: (
		state: IServicesReducer,
		{
			payload,
		}: {
			payload: {
				data: ISurveyService;
				id: number;
			};
		},
	) => ({
		...successActionHandler(state),
		isServiceCreated: true,
		categoryList: state.categoryList?.map((c) => {
			return c.id !== payload.id
				? c
				: {
						...c,
						surveyServices: [...(c.surveyServices || []), payload.data],
				  };
		}),
	}),

	[types.PATCH_SERVICE.SUCCESS]: (
		state: IServicesReducer,
		{ payload }: { payload: ISurveyService },
	) => ({
		...successActionHandler(state),
		updatedService: payload,
		newPartnerServices:
			payload.id !== payload.parentId
				? (state.newPartnerServices || []).concat(payload)
				: state.newPartnerServices?.slice(),
	}),

	[types.RESET_PATCH_SERVICE]: (state: IServicesReducer) => ({
		...successActionHandler(state),
		updatedService: undefined,
	}),

	[types.RESET_SERVICES_ERROR]: (state: IServicesReducer) => ({
		...successActionHandler(state),
	}),

	[types.RESET_PARTNER_CATEGORY_LIST]: (state: IServicesReducer) => ({
		...successActionHandler(state),
		partnerCategoryList: undefined,
	}),

	[types.RESET_CATEGORY_LIST]: (state: IServicesReducer) => ({
		...successActionHandler(state),
		categoryList: [],
	}),
});
